
import { Vue } from 'vue-class-component';

export default class LoadingScreen extends Vue {}
